import { useQuery } from "@tanstack/react-query";

import type { WorkspaceSearchParams } from "@app/common/access/ShareReport/api/workspace";
import type { WorkspaceEntity, WorkspaceEntityKind } from "@app/common/types";

import api from "../api";

type WorkspaceSearchResults = WorkspaceEntity[];
const EMPTY_SEARCH_RESULTS: WorkspaceSearchResults = [];

const searchWorkspace = async (
  workspaceId: string,
  params: { query: string | null; includeEntities?: WorkspaceEntityKind[] }
): Promise<WorkspaceSearchResults> => {
  if (!params.query) return Promise.resolve([]);

  const json = await api.workspace.searchWorkspace(
    workspaceId,
    params as WorkspaceSearchParams
  );
  return json.data;
};

const useWorkspaceSearch = (
  query: string | null,
  workspaceId?: string | null,
  opts?: { enabled?: boolean; includeEntities?: WorkspaceEntityKind[] }
) => {
  const searchQuery = useQuery({
    queryKey: ["workspaceSearch", workspaceId, query],
    queryFn: () =>
      searchWorkspace(workspaceId!, {
        query,
        includeEntities: opts?.includeEntities,
      }),
    enabled: Boolean(workspaceId) && (opts?.enabled ?? true),
  });

  return {
    isError: searchQuery.isError,
    isLoading: searchQuery.isLoading,
    searchResults: searchQuery.data ?? EMPTY_SEARCH_RESULTS,
  };
};

export default useWorkspaceSearch;
